import SEOArticleLayout from "@/components/feature/SEOArticleLayout";

const IMAGE = "https://readdy.ai/api/search-image?query=Chess%20pieces%20on%20minimal%20cream%20marble%20board%20representing%20competitive%20strategy%2C%20soft%20directional%20lighting%20from%20side%2C%20elegant%20business%20concept%20photography%2C%20warm%20cream%20and%20charcoal%20tones%2C%20clean%20minimal%20composition&width=900&height=1100&seq=seo-article-concurrents-v3&orientation=portrait";

export default function AnalyseConcurrentsPage() {
  return (
    <SEOArticleLayout
      title="Analyse des Concurrents avec le Hipobuy Spreadsheet"
      subtitle="Découvrez comment le hipobuy spreadsheet vous aide à analyser vos concurrents, comparer les prix et optimiser votre positionnement e-commerce."
      heroImageUrl={IMAGE}
      heroImageAlt="Analyse des concurrents Hipobuy Spreadsheet"
    >
      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">L'importance de l'analyse concurrentielle</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
          Dans le e-commerce, connaître ses concurrents est indispensable. Savoir qui vend quoi, à quel prix et avec quelle stratégie vous permet de prendre des décisions éclairées. Le <strong>hipobuy spreadsheet</strong> intègre des outils d'analyse concurrentielle qui automatisent cette veille.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Comment le Hipobuy Spreadsheet analyse vos concurrents</h2>
        <div className="space-y-4">
          {[
            { title: "Surveillance des prix concurrents", desc: "Le hipobuy spreadsheet suit automatiquement les prix pratiqués par vos concurrents sur les produits similaires. Vous êtes alerté dès qu'un concurrent modifie ses tarifs." },
            { title: "Identification des tendances du marché", desc: "L'outil analyse les mouvements de prix et les volumes pour identifier les tendances émergentes. Vous pouvez anticiper le marché plutôt que le subir." },
            { title: "Analyse des écarts de prix", desc: "Visualisez instantanément où vous vous situez par rapport à la concurrence. Le hipobuy spreadsheet vous montre si vous êtes trop cher ou si vous pouvez augmenter vos marges." },
            { title: "Rapports de positionnement", desc: "Générez des rapports synthétiques pour comprendre votre positionnement concurrentiel global et identifier les opportunités d'optimisation." },
          ].map((item, i) => (
            <div key={i} className="flex gap-3 p-4 bg-background-100 rounded-2xl">
              <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                <span className="text-accent-700 text-sm font-bold">{i + 1}</span>
              </div>
              <div>
                <h4 className="font-heading text-base font-semibold text-foreground-950 mb-1">{item.title}</h4>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="mt-8 p-6 bg-accent-50 rounded-2xl border border-accent-100 text-center">
        <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">Prenez l'avantage sur vos concurrents</h3>
        <p className="text-sm text-foreground-500 mb-4">Utilisez le hipobuy spreadsheet pour dominer votre marché.</p>
        <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold uppercase tracking-wider whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer">
          Accéder à la Plateforme
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </SEOArticleLayout>
  );
}